import wangge from "@/components/person/wangge";
import zyjh from "@/components/person/zyjh";
import ryfp from "@/components/person/ryfp";
import bcsd from "@/components/person/bcsd";
import attdManage from "@/components/person/attdManage";
import zycx from "@/components/person/zycx";
import clzycx from "@/components/carsys/zycx";
import pbgl from "@/components/carsys/pbgl";
import zhongzz from "@/components/zhongzz/zhongzz.vue";
import zhongzzck from "@/components/zhongzz/zhongzzck.vue";
var data = [
  {
    path: "/zzzck",
    component: zhongzzck,
  },
  {
    path: "/zzzck-A",
    component: zhongzzck,
  },
  {
    path: "/zzzgl",
    component: zhongzz,
  },
  {
    path: "/wangge",
    component: wangge,
  },
  {
    path: "/zyjh",
    component: zyjh,
  },
  {
    path: "/ryfp",
    component: ryfp,
  },
  {
    path: "/bcsd",
    component: bcsd,
  },
  {
    path: "/kqgl",
    component: attdManage,
  },
  {
    path: "/zycx",
    component: zycx,
  },
  {
    path: "/clzycx",
    component: clzycx,
  },

  {
    path: "/pbgl",
    component: pbgl,
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/qingsao.js